import { postSemData } from '@/sem2';
/* global $ */
export const tencentReport = (AToken, click_id) => {
  $.ajax({
    url: 'https://tg01.mbimc.com/api/report/tengxun-report',
    type: 'POST',
    data: { click_id: click_id },
    beforeSend: function (requst) {
      requst.setRequestHeader('AToken', AToken);
    }
  }).done(function (res) {
    console.log(res);
  });
};

export const tencentReportMp = (AToken, datas) => {
  $.ajax({
    url: 'https://tg01.mbimc.com/api/report/post-wechat-mp',
    type: 'POST',
    data: datas,
    beforeSend: function (requst) {
      requst.setRequestHeader('AToken', AToken);
    }
  }).done(function (res) {
    console.log(res);
  });
};

export const reportQihuo = (id, atoken) => {
  $.ajax({
    url: 'https://tg01.biying88.cn/index.php?r=api/report/three-report',
    type: 'POST',
    beforeSend: function (requst) {
      requst.setRequestHeader('AToken', atoken);
    },
    data: {
      qhclickid: id,
      trans_id: id,
      impression_id: id,
      id: atoken
    }
  })
    .done(function (res) {
      console.log(res);
    })
    .fail(function (res) {});
};
export const commonReport = (id) => {
  $.ajax({
    url: 'https://tg01.biying88.cn/index.php',
    type: 'get',
    ContentType: '/json',
    data: {
      r: 'api/qihuad/setsource',
      sourceid: id
    }
  })
    .done(function (res) {
      console.log(res);
    })
    .fail(function (res) {});
};
export const baiduReport = (AToken) => {
  $.ajax({
    url: 'https://tg01.biying88.cn/index.php?r=api/report/baidu-report',
    type: 'GET',
    beforeSend: function (requst) {
      requst.setRequestHeader('AToken', AToken);
    }
  }).done(function (res) {
    console.log(res);
  });
};
export const toutiaoReportNew = (AToken, params) => {
  $.ajax({
    url: 'https://tg01.biying88.cn/index.php?r=/api/report/toutiao-report-new',
    type: 'POST',
    data: params,
    beforeSend: function (requst) {
      requst.setRequestHeader('AToken', AToken);
    }
  }).done(function (res) {
    console.log(res);
  });
};

export const getQYQRCode = (opts) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      // 测试环境
      // 116.236.195.178:38089
      url: 'https://cssupport.17biying.net/api/v1/qr/info',
      type: 'get',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      // beforeSend: function (requst) {
      //   requst.setRequestHeader('checksum', checksum);
      //   requst.setRequestHeader('curtime', curtime);
      //   requst.setRequestHeader('nonce', nonce);
      // },
      success: resolve,
      error: reject
    });
  });
};

//上传code
export const fetchReportCode = (data) => {
  $.ajax({
    url: 'http://layunying-shijun.dev11.lanyicj.cn/api/wechat/pay-callback',
    type: 'GET',
    data: data
  }).done(function (res) {
    console.log(res);
  });
};

// 阿里云埋点数据上报
export const aLiReportActionLog = (eventName, opts = {}) => {
  console.log(opts);
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://tg01.biying88.cn/index.php?r=api/log/log',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: {
        data: `${handlerReportLog(eventName, opts)}`
      },
      success: resolve,
      error: reject
    });
  });
};
// 获取阿里云数据
const handlerReportLog = (appEvent, opts = {}) => {
  const { ad_clickid, scene, query, location_pageid } = opts;
  return JSON.stringify({
    appEvent,
    ad_clickid,
    scene,
    query,
    location_pageid,
    created_at: new Date().getTime()
  });
};

// 阿里云埋点数据上报 h5 0.99、12元付费 页面埋点
export const aLiReportActionLog2 = (eventName, opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://tg01.biying88.cn/index.php?r=api/log/log',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: {
        data: `${handlerReportLog2(eventName, opts)}`
      },
      success: resolve,
      error: reject
    });
  });
};

// 获取阿里云数据
const handlerReportLog2 = (appEvent, opts = {}) => {
  console.log(opts);

  const { callback, scene, url, pages, mobile } = opts;
  return JSON.stringify({
    appEvent,
    callback,
    scene,
    url,
    pages,
    mobile,
    created_at: new Date().getTime()
  });
};

// uc上报
export const ucReport = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://tornado-api.17biying.net/v2/wx-small-contact/add-uc-landing-page',
      // tornado-api.qihuo.huashengfe.cn 测试域名
      // tornado-api.17biying.net 线上域名
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

// 微信mp上报 公众号链路的mp上报
export const wxReportMp = (AToken, datas) => {
  $.ajax({
    url: 'https://yunying.langya.huashengfe.cn/api/wechat/get-code',
    type: 'POST',
    data: datas,
    beforeSend: function (requst) {
      requst.setRequestHeader('AToken', AToken);
    }
  }).done(function (res) {
    console.log(res);
  });
};
// h5跳转投顾小程序（优选股助手） h5页面数据上报接口 李德祥 支付链路（0元除外）
export const tgH5Report = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://tornado-api.17biying.net/v2/wx-small-contact/headlines-report-page',
      // tornado-api.qihuo.huashengfe.cn 测试域名
      // tornado-api.17biying.net 线上域名
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

// 头条上报 为了后期头条上报，存储基本信息。非支付链路
// 在用户添加业务员之后，后端再将这些数据统一头条上报  吴为东
export const toutiaoReportForMiniprogram = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://tornado-api.17biying.net/v2/wx-small-contact/add-tt-landing-page',
      // tornado-api.qihuo.huashengfe.cn 测试域名
      // tornado-api.17biying.net 线上域名
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};
export const toutiaoReportForMiniprogramTest = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'http://tornado-api.qihuo.huashengfe.cn/v2/wx-small-contact/add-tt-landing-page',
      // tornado-api.qihuo.huashengfe.cn 测试域名
      // tornado-api.17biying.net 线上域名
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

// h5支付 跳转投顾小程序 数据上报接口 李德祥
export const paidReportPageReport = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://tornado-api.17biying.net/v2/paid-wx-contact/paid-report-page',
      // tornado-api.qihuo.huashengfe.cn 测试域名
      // tornado-api.17biying.net 线上域名
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};
export const paidReportPageReportTest = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'http://tornado-api.qihuo.huashengfe.cn/v2/paid-wx-contact/paid-report-page',
      // tornado-api.qihuo.huashengfe.cn 测试域名
      // tornado-api.17biying.net 线上域名
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

// 线索类小程序 获取小程序跳转链接
// 开发环境
// http://cssupport-tangwt.dev.lanyicj.cn
// 测试环境
// http://cs_support_test.huashengfe.cn
// 生产环境
// http://cssupport.17biying.net
// 参数
// hashId 从链接上获取
// mediaKey 落地页上报接口返回的数据之一 用于关联当前渠道、媒体等数据
// _extra{Key} 想要带进小程序的参数
// 后端：唐文涛
export const getWxOpenlink = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cssupport.17biying.net/api/v1/slink/info',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};
export const getWxOpenlinkTest = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cs_support_test.huashengfe.cn/api/v1/slink/info',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

export const getAppOpenlink = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cssupport.17biying.net/api/v1/slink/app',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

// 请求预先生成码
// 开发环境
// http://cssupport-tangwt.dev.lanyicj.cn
// 测试环境
// http://cs_support_test.huashengfe.cn
// 生产环境
// http://cssupport.17biying.net
// 参数
// hashId 从链接上获取
// mediaKey 落地页上报接口返回的数据之一 用于关联当前渠道、媒体等数据
// 后端：唐文涛
export const getQR = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cssupport.17biying.net/api/v1/slink/qr',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};
export const getQRTest = (opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cs_support_test.huashengfe.cn/api/v1/slink/qr',
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};
// 加密一个定量secret 后端java 无测试环境
// 后端 李浩
export const getMediaKey = (curtime, nonce, checksum, opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      // 测试环境
      // 116.236.195.178:38089
      url: 'https://report.biying88.cn/api/v1/landing',
      type: 'Get',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      beforeSend: function (requst) {
        requst.setRequestHeader('checksum', checksum);
        requst.setRequestHeader('curtime', curtime);
        requst.setRequestHeader('nonce', nonce);
      },
      success: resolve,
      error: reject
    });
  });
};
export const getMediaKeyTest = (curtime, nonce, checksum, opts = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      // 测试环境
      // 116.236.195.178:38089
      url: 'http://116.236.195.178:38089/api/v1/landing',
      type: 'Get',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      beforeSend: function (requst) {
        requst.setRequestHeader('checksum', checksum);
        requst.setRequestHeader('curtime', curtime);
        requst.setRequestHeader('nonce', nonce);
      },
      success: resolve,
      error: reject
    });
  });
};
export const getActiveReport = (opts) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      // 测试环境
      // 116.236.195.178:38089
      url: 'https://report.biying88.cn/api/v1/action_report',
      type: 'get',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      // beforeSend: function (requst) {
      //   requst.setRequestHeader('checksum', checksum);
      //   requst.setRequestHeader('curtime', curtime);
      //   requst.setRequestHeader('nonce', nonce);
      // },
      success: resolve,
      error: reject
    });
  });
};
export const getInsertReport = (opts) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      // 测试环境
      // 116.236.195.178:38089
      url: 'https://report.biying88.cn/api/v1/dzhActionReport/insert',
      type: 'post',
      contentType: 'application/json',
      data: JSON.stringify(opts),
      // beforeSend: function (requst) {
      //   requst.setRequestHeader('checksum', checksum);
      //   requst.setRequestHeader('curtime', curtime);
      //   requst.setRequestHeader('nonce', nonce);
      // },
      success: resolve,
      error: reject
    });
  });
};
export const postStockReport = (opts) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      // 测试环境
      // 116.236.195.178:38089
      url: 'https://report.biying88.cn/api/v1/userBehaviorData/insert',
      type: 'post',
      contentType: 'application/x-www-form-urlencoded',
      data: opts,
      success: resolve,
      error: reject
    });
  });
};

// 参数
// hashId 从链接上获取
// 后端：唐文涛
// 开发环境
// http://cssupport-tangwt.dev.lanyicj.cn
// 测试环境
// http://cs_support_test.huashengfe.cn
// 生产环境
// http://cssupport.17biying.net
export const getQrFile = (data) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cssupport.17biying.net/api/v1/qr/file',
      type: 'GET',
      data,
      success: resolve,
      error: reject
    });
  });
};
export const getExternalFile = (data) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://cssupport.17biying.net/api/v1/qr/external-file',
      type: 'GET',
      data,
      success: resolve,
      error: reject
    });
  });
};

// 埋点上报
// hashId: 链接上的hashId
// mediaKey: 落地页返回的mediaKey
// eventKey: 事件标识
//   - 'view': 进入落地页（页面onload/SPA路由切换完成）
//   - 'click': 点击关键按钮（关键CTA、下载按钮、表单按钮等）
//   - 'submit': 提交表单（表单submit成功）
//   - 'scan': 扫描二维码事件
//   - 'leave': 离开页面（beforeunload/SPA路由切换开始）
// eventTime: 事件发生时间，格式秒级时间戳
// 开发环境用
export const landingPageTrackDev = (opts = {}) => {
  const { hashId, mediaKey, eventKey, eventTime } = opts;
  const url = 'http://cssupport-y.dev.lanyicj.cn/api/v1/landing-page-track/track';
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      type: 'POST',
      // contentType: 'application/json',
      data: JSON.stringify({ hashId, mediaKey, eventKey, eventTime }),
      success: resolve,
      error: reject
    });
  });
};

// 生产环境用
export const landingPageTrackProd = (opts = {}) => {
  const { hashId, mediaKey, eventKey, eventTime } = opts;
  const url = 'https://cssupport.17biying.net/api/v1/landing-page-track/track';
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      type: 'POST',
      // contentType: 'application/json',
      data: JSON.stringify({ hashId, mediaKey, eventKey, eventTime }),
      success: resolve,
      error: reject
    });
  });
};
